<div class="row">
  <div class="col">
    <mat-form-field>
      <mat-label>Panorama Resolution</mat-label>
      <mat-select (selectionChange)="setRes($event.value)" [value]="4096">
        <mat-option *ngFor="let item of panoramaRes" [value]="item">
          {{item}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col">
    <mat-form-field>
      <mat-label>Panorama Field of View</mat-label>
      <mat-select (selectionChange)="setFOV($event.value)" [value]="85">
        <mat-option [value]="70"> 70 </mat-option>
        <mat-option [value]="75"> 75 </mat-option>
        <mat-option [value]="80"> 80 </mat-option>
        <mat-option [value]="85"> 85 </mat-option>
        <mat-option [value]="90"> 90 </mat-option>
        <mat-option [value]="95"> 95 </mat-option>
        <mat-option [value]="100"> 100 </mat-option>
        <mat-option [value]="105"> 105 </mat-option>
        <mat-option [value]="110"> 110 </mat-option>
        <mat-option [value]="115"> 115 </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div class="col">
    <mat-checkbox (change)="setShowControls($event.checked)">Hide Panorama Controls
    </mat-checkbox>
  </div>
</div>

<div>
  <div class="row">
    <div class="col">
      <hr />
      <h2>Floor Plan</h2>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-checkbox [checked]="floorPlanInteractive" (change)="setFloorPlanInteraction($event.checked)">
        Interactive Floor Plan
      </mat-checkbox>
    </div>
  </div>

  <div class="row">
    <!-- <div class="col">
      <mat-form-field>
        <mat-label>Scale Pixels per Metre</mat-label>
        <mat-select (selectionChange)="setFPScalePixels($event.value)" [value]="20">
          <mat-option [value]="5"> 5 </mat-option>
          <mat-option [value]="10"> 10 </mat-option>
          <mat-option [value]="15"> 15 </mat-option>
          <mat-option [value]="20"> 20 </mat-option>
          <mat-option [value]="25"> 25 </mat-option>
          <mat-option [value]="30"> 30 </mat-option>
          <mat-option [value]="50"> 50 </mat-option>
          <mat-option [value]="75"> 75 </mat-option>
          <mat-option [value]="100"> 100 </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->

    <div class="col">
      <mat-form-field>
        <mat-label>Rotation in degrees</mat-label>
        <mat-select (selectionChange)="setFPRotation($event.value)" [value]="0">
          <mat-option [value]="0"> 0 </mat-option>
          <mat-option [value]="90"> 90 </mat-option>
          <mat-option [value]="180"> 180 </mat-option>
          <mat-option [value]="270"> 270 </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Floor Plan Colour</mat-label>
        <mat-select (selectionChange)="setFPColor($event.value)" [value]="'default'">
          <mat-option *ngFor="let item of fPColors" [value]="item">
            {{item}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col">
      <mat-form-field>
        <mat-label>Option Colour</mat-label>
        <mat-select (selectionChange)="setFPOptionColor($event.value)" [value]="'default'">
          <mat-option *ngFor="let item of fPColors" [value]="item">
            {{item}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Highlight Colour</mat-label>
        <mat-select (selectionChange)="setFPHighlightColor($event.value)" [value]="'default'">
          <mat-option *ngFor="let item of fPColors" [value]="item">
            {{item}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Room Name Font</mat-label>
        <mat-select (selectionChange)="setFont($event.value)" [value]="'default'">
          <mat-option [value]="'default'"> default </mat-option>
          <mat-option [value]="'SourceSerifPro-Regular.otf.woff'"> SourceSansPro </mat-option>
          <mat-option [value]="'SourceSansPro-Bold.otf'"> SourceSansPro (Bold)</mat-option>
          <mat-option [value]="'SourceCodePro-It.ttf'"> SourceCodePro (Italic)</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- <div class="col">
      <mat-form-field>
        <mat-label>Room Name Size</mat-label>
        <mat-select (selectionChange)="setFontSize($event.value)" [value]="'10px'">
          <mat-option [value]="'8px'"> 8px </mat-option>
          <mat-option [value]="'10px'"> 10px </mat-option>
          <mat-option [value]="'14px'"> 14px </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
  </div>
</div>
